export const setCompanyFilter = (state, { key, value }) => {
  let currentFilters = state.companyFilter || "";
  const filterMap = new URLSearchParams(currentFilters);
  if (value === null) {
    filterMap.delete(key);
  } else {
    filterMap.set(key, value);
  }
  state.companyFilter = filterMap.toString();
  console.log("Nuevo filtro:", state.companyFilter);
};
export const setState = (state, { key, value }) => {
  state[key] = value;
};
export const removeState = (state, { key, keySearch, value }) => {
  state[key].data.results = state[key].data.results.filter(
    (item) => item[keySearch] !== value
  );
};
export const addEnty = (state, { key, value }) => {
  console.log("key---->:", key, "value---->", value);
  if (!state[key]) {
    state[key] = { data: { results: [] } };
  }
  if (!state[key].data) {
    state[key].data = { results: [] };
  }
  if (!Array.isArray(state[key].data.results)) {
    state[key].data.results = [];
  }
  state[key].data.results = [value, ...state[key].data.results];
};

export const updateState = (state, { key, keySearch, value, data }) => {
  console.log(key, keySearch, value);
  let index = state[key].data.results.findIndex(
    (item) => item[keySearch] === value
  );
  console.log("INDEX: ", index);
  state[key].data.results[index] = data;
};

export const setFilter = (state, { key, value, enty }) => {
  let currentFilters = state[enty] || "";
  const filterMap = new URLSearchParams(currentFilters);
  filterMap.delete(key);
  if (Array.isArray(value)) {
    value.forEach((val) => {
      if (val !== null && val !== "") {
        filterMap.append(key, val);
      }
    });
  } else if (value !== null && value !== "") {
    filterMap.set(key, value);
  }
  state[enty] = filterMap.toString();
};

export const setUserColors = (state, payload) => {
  state.userColors = payload;
};

export const updateDataset = (state, { datasetName, newData }) => {
  if (state[datasetName]) {
    state[datasetName].data = newData;
  }
};
export const setMetricColors = (state, metricColorMap) => {
  state.metricColors = metricColorMap;
};
export const setStateFilter = (state, { stateName, attrName, data }) => {
  state[stateName][attrName] = data;
};
